export const data = [ // тип обрабатываемых данных
    {
        id: 1,
        sessionId: '132dcefvrgvg',
        startedTime: '12-03-24',
        surveyPlan: {
            chooses: [
                { stepTime1: '12-03-24', variants: ['survey-1', 'survey-4', 'survey-2'] },
                { stepTime1: '12-04-24', variants: ['survey-3', 'survey-5', 'survey-2'] },
                { stepTime1: '12-05-24', variants: ['survey-3', 'survey-1', 'survey-2'] }
            ],
            commentarySurvey: 'Hello world-survey'
        },
        principalDiagnosis: {
            chooses: [
                { stepTime2: '12-03-24', variants: ['diagnosis-1'] },
                { stepTime2: '12-03-24', variants: ['diagnosis-3'] },
                { stepTime2: '12-03-24', variants: ['diagnosis-5'] }
            ],
            commentaryDiagnosis: 'Hello world-diagnosis'
        },
        progressionFactors: {
            chooses: [
                { stepTime3: '12-03-24', variants: ['Factors-1'] },
                { stepTime3: '12-03-24', variants: ['Factors-3'] },
                { stepTime3: '12-03-24', variants: ['Factors-5'] }
            ],
            commentaryFactors: 'Hello world-Factors'
        },
        treatment: {
            chooses: [
                { stepTime4: '12-03-24', variants: ['treatment-1', 'treatment-4', 'treatment-2'] },
                { stepTime4: '12-03-24', variants: ['treatment-1', 'treatment-4', 'treatment-2'] },
                { stepTime4: '12-03-24', variants: ['treatment-5', 'treatment-6', 'treatment-2'] }
            ],
            commentaryTreatment: 'Hello world-treatment'
        },
        endedTime: '12-04-24'
    }
    // {
    //     id: 2,
    //     sessionId: 'wfwregrtg43566',
    //     startedTime: '12-04-24',
    //     surveyPlan: {
    //         chooses: [
    //             { stepTime1: '12-04-24', variants: ['survey-1', 'survey-4', 'survey-2'] },
    //             { stepTime1: '12-04-24', variants: ['survey-3', 'survey-5', 'survey-2'] },
    //             { stepTime1: '12-04-24', variants: ['survey-3', 'survey-1', 'survey-2'] }
    //         ],
    //         commentarySurvey: 'Hello world-survey'
    //     },
    //     principalDiagnosis: {
    //         chooses: [
    //             { stepTime2: '12-04-24', variants: ['diagnosis-1'] },
    //             { stepTime2: '12-04-24', variants: ['diagnosis-1'] },
    //             { stepTime2: '12-04-24', variants: ['diagnosis-5'] }
    //         ],
    //         commentaryDiagnosis: 'Hello world-diagnosis'
    //     },
    //     treatment: {
    //         chooses: [
    //             { stepTime3: '12-04-24', variants: ['treatment-1', 'treatment-4', 'treatment-2'] },
    //             { stepTime3: '12-04-24', variants: ['treatment-1', 'treatment-4', 'treatment-2'] },
    //             { stepTime3: '12-04-24', variants: ['treatment-5', 'treatment-6', 'treatment-2'] }
    //         ],
    //         commentaryTreatment: 'Hello world-treatment'
    //     },
    //     endedTime: '12-05-24'
    // },
    // {
    //     id: 3,
    //     sessionId: '111111111',
    //     startedTime: '12-04-24',
    //     surveyPlan: {
    //         chooses: [
    //             { stepTime1: '12-04-24', variants: ['survey-1', 'survey-4', 'survey-2'] },
    //             { stepTime1: '12-04-24', variants: ['survey-3', 'survey-5', 'survey-2'] },
    //             { stepTime1: '12-04-24', variants: ['survey-3', 'survey-1', 'survey-2'] }
    //         ],
    //         commentarySurvey: 'Hello world-survey'
    //     },
    //     principalDiagnosis: {
    //         chooses: [
    //             { stepTime2: '12-04-24', variants: ['diagnosis-1'] },
    //             { stepTime2: '12-04-24', variants: ['diagnosis-1'] },
    //             { stepTime2: '12-04-24', variants: ['diagnosis-5'] }
    //         ],
    //         commentaryDiagnosis: 'Hello world-diagnosis'
    //     },
    //     treatment: {
    //         chooses: [
    //             { stepTime3: '12-04-24', variants: ['treatment-1', 'treatment-4', 'treatment-2'] },
    //             { stepTime3: '12-04-24', variants: ['treatment-1', 'treatment-4', 'treatment-2'] },
    //             { stepTime3: '12-04-24', variants: ['treatment-5', 'treatment-6', 'treatment-2'] }
    //         ],
    //         commentaryTreatment: 'Hello world-treatment'
    //     },
    //     endedTime: '12-05-24'
    // },
];

export const allStatistic = (data) => {
    const resultObj = {
        all_counts: data.length,
        all_survey_plan: {
            count: 0,
            middle_try: 0,
            result() {
                return (this.middle_try / this.count).toFixed(0)
            }
        },
        all_diagnosis: {
            count: 0,
            middle_try: 0,
            result() {
                return (this.middle_try / this.count).toFixed(0)
            }
        },
        all_factors: {
            count: 0,
            middle_try: 0,
            result() {
                return (this.middle_try / this.count).toFixed(0)
            }
        },
        all_treatment: {
            count: 0,
            middle_try: 0,
            result() {
                return (this.middle_try / this.count).toFixed(0)
            }
        },
        all_alpha_adrenoblocker: {
            count: 0,
            middle_try: 0,
            result() {
                return (this.middle_try / this.count).toFixed(0)
            }
        },
        all_future_treatment: {
            count: 0,
            middle_try: 0,
            result() {
                return (this.middle_try / this.count).toFixed(0)
            }
        },
        all_end: 0
    }
    for (let i in data) {
        for (let key in data[i]) {
            // console.log(key)
            switch (key) {
                case "surveyplan":
                    if (data[i][key])
                        resultObj.all_survey_plan = {
                            ...resultObj.all_survey_plan, count: resultObj.all_survey_plan.count + 1,
                            middle_try: resultObj.all_survey_plan.middle_try + data[i][key].chooses.length
                        }
                    break;
                case 'principaldiagnosis':
                    if (data[i][key])
                        resultObj.all_diagnosis = {
                            ...resultObj.all_diagnosis, count: resultObj.all_diagnosis.count + 1,
                            middle_try: resultObj.all_diagnosis.middle_try + data[i][key].chooses.length
                        }
                    break;
                case 'progressionfactors':
                    if (data[i][key])
                        resultObj.all_factors = {
                            ...resultObj.all_factors, count: resultObj.all_factors.count + 1,
                            middle_try: resultObj.all_factors.middle_try + data[i][key].chooses.length
                        }
                    break;
                case 'treatment':
                    if (data[i][key])
                        resultObj.all_treatment = {
                            ...resultObj.all_treatment, count: resultObj.all_treatment.count + 1,
                            middle_try: resultObj.all_treatment.middle_try + data[i][key].chooses.length
                        }
                    break;
                case 'alpha_adrenoblocker':
                    if (data[i][key])
                        resultObj.all_alpha_adrenoblocker = {
                            ...resultObj.all_alpha_adrenoblocker, count: resultObj.all_alpha_adrenoblocker.count + 1,
                            middle_try: resultObj.all_alpha_adrenoblocker.middle_try + data[i][key].chooses.length
                        }
                    break;
                case 'futuretreatment':
                    if (data[i][key])
                        resultObj.all_future_treatment = {
                            ...resultObj.all_future_treatment, count: resultObj.all_future_treatment.count + 1,
                            middle_try: resultObj.all_future_treatment.middle_try + data[i][key].chooses.length
                        }
                    break;
                case 'endedtime':
                    if (data[i][key])
                        resultObj.all_end = resultObj.all_end + 1
                    break;
                default:
                    break;
            }
        }
    }
    return resultObj
}